import { normalizeCollectionResponse, normalizeRecordResponse, productParams } from 'api';
import { client } from 'queries';

export const productQuery = async ({ req, params }) => {
	const response = await client.apiRequest({ url: `/products/${params.productId}`, params: productParams });
	return normalizeRecordResponse(response);
};

export const productsQuery = async ({ req, params, query }) => {
	const response = await client.apiRequest({ url: `/products`, params: productParams });
	return normalizeCollectionResponse(response);
};
